import { gql } from 'apollo-client-ppc';

export const fetchCompaniesInPPC = gql`
  query fetchCompaniesInPPC($searchParams: ShipToPartySearchParams) {
    shipToParty(searchParams: $searchParams) {
      nodes {
        id
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        priceEligibility
      }
    }
  }
`;
